import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import passwordResetSlice from './slices/passwordResetSlice';
import forecastSlice from './slices/forecastSlice';
import savedSpotsSlice from './slices/savedSpotsSlice'
import daylyForecastSlice from './slices/daylyForecastSlice'
import hourlyForecastSlice from './slices/hourlyForecastSlice'
import liveDataSlice from './slices/liveDataSlice';
import cookieAcceptanceSlice from './slices/cookieAcceptanceSlice';
import alertPreferencesSlice from './slices/alertPreferencesSlice';
import contactSupportSlice from './slices/contactSupportSlice';
import themeSlice from './slices/themeSlice';
import savingIndicatorSlice from './slices/savingIndicatorSlice';
import savingIndicatorMiddleware from './middleware/savingIndicatorMiddleware';

// A request interrupted by closing the tab would otherwise rehydrate as "still loading" forever.
const resetLoadingTransform = createTransform(
  (inbound) => inbound,
  (outbound) => ({
    ...outbound,
    isLoading: false,
    ...(outbound?.loadingIds ? { loadingIds: [] } : {}),
    ...(outbound && 'isLoadingReport' in outbound ? { isLoadingReport: false } : {}),
  }),
  { whitelist: ['forecast', 'dailyForecast', 'hourlyForecast', 'liveData', 'alertPreferences'] }
);

const persistConfig = {
  key: 'root',
  storage,
  transforms: [resetLoadingTransform],
  whitelist: ['auth', 'forecast', 'savedSpots', 'dailyForecast', 'hourlyForecast', 'liveData', 'cookieAcceptance', 'alertPreferences', 'theme'],
};

const rootReducer = combineReducers({
  auth: authSlice,
  passwordReset: passwordResetSlice,
  savedSpots: savedSpotsSlice,
  forecast: forecastSlice,
  dailyForecast: daylyForecastSlice,
  hourlyForecast: hourlyForecastSlice,
  liveData: liveDataSlice,
  cookieAcceptance: cookieAcceptanceSlice,
  alertPreferences: alertPreferencesSlice,
  contactSupport: contactSupportSlice,
  theme: themeSlice,
  savingIndicator: savingIndicatorSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(savingIndicatorMiddleware),
});

export const persistor = persistStore(store);
export const RootState = store.getState;
export const AppDispatch = store.dispatch;